import React from "react";
import PropTypes from "prop-types";
import TestimonialCard from "./TestimonialCard";
import "../../Styles/TestimonialCard.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination, Autoplay } from "swiper/modules";

export default function TestimonialsSection({ title, items }) {
  // ✅ Duplicate items to make loop smooth
  const loopItems = items.length < 4 ? [...items, ...items, ...items] : items;

  return (
    <section
      style={{ marginBottom: "5%", marginTop: "5%" }}
      className="testimonials-section"
    >
      <div className="testimonials-header">
        <h4 className="testimonials-title">{title}</h4>
      </div>

      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={3}   // ✅ show perfect 3 cards
        loop={true}
        speed={800}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        breakpoints={{
          320: { slidesPerView: 1 },
          769: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {loopItems.map((it, index) => (
          <SwiperSlide key={index}>
            <TestimonialCard {...it} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

TestimonialsSection.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
};

TestimonialsSection.defaultProps = {
  title: "What Our Customers Say About Us",
  items: [],
};
